import { createReducer, on } from '@ngrx/store';
import { InstaPost } from '../../models';
import * as pageActions from '../actions/instagram.action';
import * as utility from '../../../utility';

export interface InstagramState {
  entities: { [instagramId: number]: InstaPost };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: InstagramState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const InstaPostReducer = createReducer(
  initialState,
  on(pageActions.LoadInstaPosts, (state: InstagramState) => {
    return {
      ...state,
      loaded: false,
      loading: true,
    };
  }),
  on(pageActions.LoadInstaPostsSuccess, (state: InstagramState, { instaPosts }) => {
    const entities = utility.ToEntities(instaPosts, 'instagramId', state.entities);
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadInstaPostsFail, (state: InstagramState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getInstaPostsEntities = (state: InstagramState) => state.entities;
export const getInstaPostsLoading = (state: InstagramState) => state.loading;
export const getInstaPostsLoaded = (state: InstagramState) => state.loaded;
